import { Validator } from "../validator"

enum NricError {
    PATTERN = `errors.invalid_nric`,
    EMPTY = `errors.required`,
    CHECKSUM = `errors.checksum`,
}

class NricValidator implements Validator<string, NricError> {
    validate(entry: string): NricError | undefined {
        const PATTERN = /^[STFGM][0-9]{7}[A-Z]$/i

        if (entry === ``) {
            return NricError.EMPTY
        }

        if (!PATTERN.test(entry)) {
            return NricError.PATTERN
        }

        if (!this.checksum(entry)) {
            return NricError.CHECKSUM
        }
    }

    checksum(nric: string): boolean {
        const FIRST_CHAR_INDEX = 0
        const LAST_CHAR_INDEX = 8

        const WEIGHT_FIRST = 2
        const WEIGHT_SECOND = 7
        const WEIGHT_THIRD = 6
        const WEIGHT_FOURTH = 5
        const WEIGHT_FIFTH = 4
        const WEIGHT_SIXTH = 3
        const WEIGHT_SEVENTH = 2

        const ADD = 4
        const ADD_M = 3
        const DIVIDE = 11

        const weights = [WEIGHT_FIRST, WEIGHT_SECOND, WEIGHT_THIRD, WEIGHT_FOURTH, WEIGHT_FIFTH, WEIGHT_SIXTH, WEIGHT_SEVENTH]

        const nricLetterST = [`J`, `Z`, `I`, `H`, `G`, `F`, `E`, `D`, `C`, `B`, `A`]
        const nricLetterFG = [`X`, `W`, `U`, `T`, `R`, `Q`, `P`, `N`, `M`, `L`, `K`]
        const nricLetterM = [`X`, `W`, `U`, `T`, `R`, `Q`, `P`, `N`, `J`, `L`, `K`]

        let total = 0

        const firstChar = nric.charAt(FIRST_CHAR_INDEX).toLocaleUpperCase()
        const lastChar = nric.charAt(LAST_CHAR_INDEX).toLocaleUpperCase()

        // Only keep digits
        nric = nric.substring(1, nric.length - 1)

        // multiply each digit in the nric number by it's weight in order
        for (let i = 0; i < nric.length; i++) {
            total += parseInt(nric.charAt(i)) * weights[i]
        }

        // If letters is T or G, add 4 to the total
        if ([`T`, `G`].includes(firstChar)) {
            total += ADD
        }

        // If letters is M, add 3 to the total
        if ([`M`].includes(firstChar)) {
            total += ADD_M
        }

        const letterIndex = total % DIVIDE

        if ([`T`, `S`].includes(firstChar)) {
            return nricLetterST[letterIndex] === lastChar
        } else if ([`F`, `G`].includes(firstChar)) {
            return nricLetterFG[letterIndex] === lastChar
        } else if ([`M`].includes(firstChar)) {
            return nricLetterM[letterIndex] === lastChar
        } else {
            return false
        }
    }

    generatesLastChar(firstChar: string, numbers: string): string {
        const WEIGHT_FIRST = 2
        const WEIGHT_SECOND = 7
        const WEIGHT_THIRD = 6
        const WEIGHT_FOURTH = 5
        const WEIGHT_FIFTH = 4
        const WEIGHT_SIXTH = 3
        const WEIGHT_SEVENTH = 2

        const ADD = 4
        const ADD_M = 3
        const DIVIDE = 11

        const weights = [WEIGHT_FIRST, WEIGHT_SECOND, WEIGHT_THIRD, WEIGHT_FOURTH, WEIGHT_FIFTH, WEIGHT_SIXTH, WEIGHT_SEVENTH]

        const nricLetterST = [`J`, `Z`, `I`, `H`, `G`, `F`, `E`, `D`, `C`, `B`, `A`]
        const nricLetterFG = [`X`, `W`, `U`, `T`, `R`, `Q`, `P`, `N`, `M`, `L`, `K`]
        const nricLetterM = [`X`, `W`, `U`, `T`, `R`, `Q`, `P`, `N`, `J`, `L`, `K`]

        let total = 0

        // multiply each digit in the nric number by it's weight in order
        for (let i = 0; i < numbers.length; i++) {
            total += parseInt(numbers.charAt(i)) * weights[i]
        }

        // If letters is T or G, add 4 to the total
        if ([`T`, `G`].includes(firstChar)) {
            total += ADD
        }

        // If letters is M, add 3 to the total
        if ([`M`].includes(firstChar)) {
            total += ADD_M
        }

        const letterIndex = total % DIVIDE

        if ([`T`, `S`].includes(firstChar)) {
            return nricLetterST[letterIndex]
        } else if ([`F`, `G`].includes(firstChar)) {
            return nricLetterFG[letterIndex]
        } else if ([`M`].includes(firstChar)) {
            return nricLetterM[letterIndex]
        } else {
            return ``
        }
    }
}

export default NricValidator
export { NricError }